import { httpRequest } from '@/clients/http'
import { local } from '@/db/repositories/local'
import * as catalog from '@/db/repositories/catalog'
import { configService } from '@/services/ConfigService'
import { Paginated, PosHttpParams, PosModel } from '@/types'

/** With a backend, the catalog is read from the device database; the demo keeps its in-memory API. */
export const ProductModel = {
  getList: (query?: PosHttpParams.ProductList) =>
    configService.isDemo()
      ? httpRequest<Paginated<PosModel.Product>>({ method: 'get', url: '/pos/products', query: { ...query } })
      : local(catalog.getProducts(query)),

  getByBarcode: (code: string) =>
    configService.isDemo()
      ? httpRequest<PosModel.Product>({ method: 'get', url: `/pos/products/barcode/${encodeURIComponent(code)}` })
      : local(catalog.getProductByCode(code).then((p) => p ?? Promise.reject(new Error('No product with that code.')))),

  /** Device only (A9). */
  create: (body: catalog.NewProduct) => local(catalog.createProduct(body)),

  /** Device only: the demo catalog has no PLU codes. */
  getByPlu: (plu: string) => local(catalog.getProductByPlu(plu)),
}
